import { render, staticRenderFns } from "./FunctionCard.vue?vue&type=template&id=3b646492&scoped=true"
import script from "./FunctionCard.vue?vue&type=script&lang=ts"
export * from "./FunctionCard.vue?vue&type=script&lang=ts"
import style0 from "./FunctionCard.vue?vue&type=style&index=0&id=3b646492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b646492",
  null
  
)

export default component.exports